import { P as PubSub } from './pubsub-COBwjfLh.js';
import './notyf-DIw0RvBj.js';
import { f as fetchHTML } from './fetchHTML-CGNR3V1z.js';
import './parseHTML-Om2c1Ayj.js';

class ProductVariantSelect extends HTMLElement {
  #abortController;
  #url = this.dataset.url;
  #sectionId = this.dataset.sectionId;
  #productId = this.dataset.productId;
  #isQuickShop = this.#sectionId?.includes('fetch-quick-shop');

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = event.target.closest('[data-variant-id]');
      if (target && !this.#abortController) this.#handleVariantChange({ target });
    });
  }

  /**
   * Handle variant change
   * @param {Event} event - The event object
   */
  async #handleVariantChange({ target }) {
    if (this.#abortController) return;
    this.#abortController = new AbortController();

    const { variantId } = target.dataset;
    const params = this.#createParams(variantId);

    try {
      PubSub.publish('variant:changing', { id: this.#productId });
      const html = await fetchHTML(`${this.#url}?${params}`, {
        signal: this.#abortController.signal,
      });

      PubSub.publish('variant:change', {
        id: this.#productId,
        data: { html },
      });

      if (this.#isQuickShop) return;

      this.#updateURL(variantId);
    } catch (error) {
      console.error('Error handling variant change:', error);
    } finally {
      this.#abortController = null;
      this.#restoreFocus(variantId);
    }
  }

  /**
   * Restore focus to the selected variant after the DOM is replaced.
   * @param {string} variantId - The variant ID
   */
  #restoreFocus(variantId) {
    document
      .querySelector(
        `product-variant-select[data-product-id="${this.#productId}"] [data-variant-id="${variantId}"]`
      )
      ?.focus();
  }

  /**
   * Update the URL with the new variant ID
   * @param {string} variantId - The variant ID
   */
  #updateURL(variantId) {
    const { searchParams } = new URL(window.location);
    searchParams.set('variant', variantId);
    history.replaceState(null, '', `${window.location.pathname}?${searchParams}`);
  }

  /**
   * Create the parameters for the URL
   * @param {string} variantId - The variant ID
   * @returns {string} The parameters
   */
  #createParams(variantId) {
    const params = [`variant=${variantId}`];
    if (this.#isQuickShop) {
      params.push('view=quick-shop');
    } else {
      params.push(`section_id=${this.#sectionId}`);
    }
    return params.join('&');
  }
}

customElements.define('product-variant-select', ProductVariantSelect);
